export default function (context, {field, value}) {
    let data = {};
    data[field] = value;
    context.commit('set', data);
}